import { render, staticRenderFns } from "./subcategoryList.vue?vue&type=template&id=82d4defa&"
import script from "./subcategoryList.vue?vue&type=script&lang=js&"
export * from "./subcategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports